import { render, staticRenderFns } from "./IconFlags.vue?vue&type=template&id=18094c00&"
import script from "./IconFlags.vue?vue&type=script&lang=js&"
export * from "./IconFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports